import styled from "styled-components";
import { modalProps } from "../../../../Component/Interface/Modal";
import { RowView, RowView2 } from "../../../../Component/style/common_style";
import { amountFormat } from "../../../../Component/tool/Tools";


interface CompleteModalProps extends modalProps {
  chargeCoin: number;
  depositorName: string;
  myCoin: number | null;
  handleCharge?: () => void;
  handleCheck?: () => void;
}

const CompleteModal = ({
  visible,
  handleModal,
  chargeCoin,
  depositorName,
  myCoin,
  handleCharge,
  handleCheck,
}: CompleteModalProps) => {
  const closeModal = () => {
    handleModal();
    handleCheck && handleCheck();
    handleCharge && handleCharge();
  };
  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };



  return (
    <Container
      style={visible ? {} : { display: "none" }}
      onClick={stopPropagation}
    >
      <ModalBox>
        <Title>입금 정보</Title>
        <ContentDiv>
          <div className="medium">무통장 입금</div>
          <div>아래 계좌에 입금 후 운영자가 입금 내역을 확인하면 코인이 지급됩니다.</div>
        </ContentDiv>
        <RowView2 style={{ marginBottom: 30 }}>
          <InfoDiv>
            <div>입금은행/예금주</div>
            <div>입금계좌</div>
            <div>입금대기금액</div>
            <div>입금자명</div>
          </InfoDiv>
          <InfoDiv>
            <div className="bankInfo">광주은행 / 이헌영(링크캠퍼스)</div>
            <div className="bankInfo">1121-024-896929</div>
            <div className="bankInfo">
              {amountFormat(chargeCoin * 100)}원
              <div className="gray">({amountFormat(chargeCoin)}C)</div>
            </div>
            <div className="bankInfo">{depositorName}</div>
          </InfoDiv>
        </RowView2>
        <BtnDiv>
          <ApplyBtn type="button" onClick={closeModal}>확인</ApplyBtn>
        </BtnDiv>
      </ModalBox>
    </Container>
  );
};
export default CompleteModal;

const Container = styled.div`
  z-index: 99;
  background-color: #00000085;
  position: fixed;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: calc(100% - 24px);
  max-width: 50rem;
  margin: auto 0rem;
  background-color: var(--admin-theme-surface, white);
  color: var(--admin-ink);
  border-radius: 8px;
  padding: 34px 24px;
  div.info {
    color: var(--admin-muted);
    font-size: 14px;
    text-align: center;
    line-height: 19px;
  }
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  overscroll-behavior: contain;
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 20px;
  font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
`;

const SubTitle = styled.div`
  font-size: 18px;
  font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
  margin-bottom: 24px;
`;

const ContentDiv = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: var(--font-family-base); font-weight: var(--font-weight-regular);
  flex-direction: column;
  text-align: center;
  color: var(--admin-muted);
  border-top: 1px solid var(--admin-theme-border, #f0f0f0);
  border-bottom: 1px solid var(--admin-theme-border, #f0f0f0);
  margin: 30px 0px;
  gap: 8px;
  .medium {
    font-family: var(--font-family-base); font-weight: var(--font-weight-medium);
    color: var(--admin-theme-text, black);
    font-size: 16px;
  }
`;

const BtnDiv = styled(RowView)`
  position: relative;
  width: 100%;
`;

const Btn = styled.button`
  border: 0;
  border-radius: 8px;
  padding: 14px 30px;
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 16px;
  font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
  cursor: pointer;
`;

const CancelBtn = styled(Btn)`
  margin-right: 5px;
  background-color: var(--admin-theme-raised, #f8f8f8);
  color: var(--admin-muted);
`;

const ApplyBtn = styled(Btn)`
  margin-left: 5px;
  background: linear-gradient(135deg, var(--admin-accent), var(--admin-accent-deep));
  color: white;
`;

const InfoDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 130px;
  color: var(--admin-muted);
  .bankInfo {
    width: 300px;
    font-family: var(--font-family-base); font-weight: var(--font-weight-medium);
    font-size: 16px;
    color: var(--admin-theme-text, black);
    flex-direction: row;
    display: flex;

    .gray {
      color: var(--admin-muted);
    }
  }
`;
